module.exports = __webpack_public_path__ + "fonts/Segoe UI Bold.65099f98.ttf";